module.exports = __webpack_public_path__ + "img/truck.f65a9205.png";